import { render, staticRenderFns } from "./LotWizard.vue?vue&type=template&id=6255be26&"
import script from "./LotWizard.vue?vue&type=script&lang=js&"
export * from "./LotWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports